import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import TabsBar from './TabsBar';
import { Menu } from 'lucide-react'; // Keeping Menu if needed, though TopBar has its own.
import { LayoutProvider, useLayout } from '../contexts/LayoutContext';

function GlobalHotkeys() {
    const navigate = useNavigate();
    const { toggleCompact } = useLayout();

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.altKey) {
                switch (e.key.toLowerCase()) {
                    case 's':
                        e.preventDefault();
                        navigate('/socios/buscar');
                        break;
                    case 'i':
                        e.preventDefault();
                        navigate('/');
                        break;
                    case 'c':
                        e.preventDefault();
                        toggleCompact();
                        break;
                    default:
                        break;
                }
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [navigate, toggleCompact]);

    return null;
}

export default function MainLayout({ children }) {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    return (
        <LayoutProvider>
            <GlobalHotkeys />
            <div className="min-h-screen bg-slate-50 flex transition-colors duration-500">
                {/* Sidebar */}
                <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />

                {/* Main Content Wrapper */}
                <div className="flex-1 flex flex-col md:pl-72 transition-all duration-300 ease-in-out">

                    {/* Top Navbar */}
                    <TopBar onMenuClick={() => setIsSidebarOpen(!isSidebarOpen)} />

                    {/* MDI Tabs Bar */}
                    <TabsBar />

                    {/* Content Area */}
                    <main className="flex-1 overflow-y-auto">
                        <div className="max-w-7xl mx-auto p-6 md:p-8 animate-premium-in">
                            {children ? children : <Outlet />}
                        </div>
                    </main>
                </div>
            </div>
        </LayoutProvider>
    );
}
